import errorMap from '../constants/error_map';
import Logger from '../support/logger';

const log = new Logger();

export default {
  data: {
    errorMsg: false,
    errorObj: false,
    isGoogleMergeMsg: false
  },
  methods: {
    logError() {
      const msg = this.errorObj.body || this.errorObj.message;
      log.error({
        category: 'error',
        message: msg,
        data: {
          status: this.errorObj.status
        }
      });
    },
    showError() {
      this.errorMsg = errorMap[this.errorObj.status] || errorMap[404];
      this.isGoogleMergeMsg = this.errorObj.status === 422;
    }
  },
  watch: {
    errorObj(val) {
      this.processing = false;
      this.errorMsg = '';
      if (val) {
        this.showError();
        this.logError();
      }
    }
  }
};
